import React from "react";
import Grid from "@material-ui/core/Grid";
import Header from "../Header";
import Companies0529 from "../components/Companies0529";
import Head from "../components/Head";
import Companies from "../components/Companies";
import University from "../components/university";
import arrow from "../assets/images/arrow.png";
import sessionImage from "../assets/images/sessionImage.png";
import logo from "../assets/images/logo.png";
import headImage from "../assets/images/session0614/topImage0614.png";
import dialogger from "../assets/images/dialogger.png";

import shareImage from "../assets/images/session0614/shareImage.png";
import Twemb from "../Twemb";
import "../css/session0614.css";
const Session0614 = (props) => {
  return (
    <>
      <img src={shareImage} style={{ display: "none" }} alt="" />
      <Head
        title="第3回！オンライン合同企業説明会2020"
        body="6月14日にオンラインで合同企業説明会を行います。22卒を中心に、その他の学年も参加可能！"
      />
      <img
        src={headImage}
        className="headImage2"
        alt="headerImage"
        onMouseDownCapture={() => {
          return false;
        }}
        onSelectCapture={() => {
          return false;
        }}
      />
      <p style={{ textAlign: "center" }}>参加はこちらから！</p>
      <p className="form3">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3GBXl0D5DyrDbXpZy4OiutzlaHZ9_7G343K09fILMpSc72g/viewform">
          参加申込フォーム
        </a>
      </p>

      <div className="container">
        <Header title="開催にあたって" name="peach-header3" />
        <p className="contents">
          約700名と23社の参加があった道内オンライン合同企業説明会(4/25)を、今度は22卒向け・インターンシップ情報メインで開催します！
          道内学生と道内に拠点を持つ企業の合同企業説明会です。
          新型コロナウィルスの影響で対面イベントが中止になっている中で、オンラインで就活を始めてみませんか？
        </p>

        <Header title="開催予定日" name="peach-header3" />
        <p className="contents">6月14日10時～18時（予定）</p>

        <Header title="対象" name="peach-header3" />
        <p className="contents">
          道内企業と道内就職希望の学生（22卒中心、その他の学年も参加可）
        </p>
        <p className="form3">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3GBXl0D5DyrDbXpZy4OiutzlaHZ9_7G343K09fILMpSc72g/viewform">
            参加申込フォーム
          </a>
        </p>

        <Header title="オンライン合説のイメージ" name="peach-header3" />
        <img
          src={sessionImage}
          className="contents sessionImage"
          alt="sessionImage"
        />

        <Header title="参加方法・用意するもの" name="peach-header3" />
        <p className="form3">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3GBXl0D5DyrDbXpZy4OiutzlaHZ9_7G343K09fILMpSc72g/viewform">
            参加申込フォーム
          </a>
        </p>
        <p className="contents">
          ・上のボタンより、参加申込みをお願いいたします。
          <br />
          ・当日使用するスマホ・PCに、「zoom」アプリをインストールしておいてください。
          <br />
          （iPhoneは
          <a href="https://apps.apple.com/us/app/id546505307">コチラ</a>{" "}
          、Androidは
          <a href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings">
            コチラ
          </a>{" "}
          、PCは<a href="https://zoom.us/download#client_4meeting">コチラ</a>
          インストール所要時間5分程度）
          <br />
          ・当日使用するzoomのURL（登録メールアドレスに前日までにお送りいたします）
          <br />
          ・【任意】企業の事前配布資料を読んできてください(一部の企業のみ)。事前配布資料は以下のボタンでGoogleドライブからダウンロードすることができます。
        </p>
        <p className="pre0529">
          <a href="https://bit.ly/3cNyi30">事前配布資料</a>
        </p>

        <Header title="当日のスケジュール" name="peach-header3" />
        <p className="contents">
          ・各タームの10分前に指定のURLをクリックしてください。
          <br />
          ・当日は各ルームに司会がおりますので司会の指示に従ってください。
          <br />
        </p>
        <table className="tg contents">
          <tbody>
            <tr>
              <th></th>
              <th className="centerTitle0614-1">全体の流れ</th>
              <th className="centerTitle0614-2">ルームA</th>
              <th className="centerTitle0614-2">ルームB</th>
              <th className="centerTitle0614-2">ルームC</th>
              <th className="centerTitle0614-2">ルームD</th>
            </tr>
            <tr>
              <td className="center time">9:30〜10:00</td>
              <td className="center compSession0614-1">OPEN</td>
              <td className="center compSession0614-2" colSpan="5">
                OPEN・待機(ルームA)
              </td>
            </tr>

            <tr>
              <td className="center time">10:00〜10:20</td>

              <td className="center compSession0614-1">全体説明</td>
              <td className="center compSession0614-2" colSpan="5">
                全体説明・オンライン説明会の受け方、事前知識セミナー（ルームA）
              </td>
            </tr>
            <tr>
              <td className="center time">10:20〜10:50</td>
              <td className="center compSession0614-1">１ターム</td>
              <td className="center compSession0614-2">
                ロゴスホーム(住宅・建設業)
              </td>
              <td className="center compSession0614-2">SOC(IT)</td>
              <td className="center compSession0614-2">
                合田観光商事(アミューズメント)
              </td>
              <td className="center compSession0614-2">井上技研(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">11:00〜11:30</td>
              <td className="center compSession0614-1">2ターム</td>
              <td className="center compSession0614-2">
                コープさっぽろ(生活協同組合)
              </td>
              <td className="center compSession0614-2">
                キットアライブ(IT（システム開発）)
              </td>
              <td className="center compSession0614-2">札幌市役所(官公庁)</td>
              <td className="center compSession0614-2">檜山鐵工所(鉄工業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">11:40〜12:10</td>
              <td className="center compSession0614-1">3ターム</td>
              <td className="center compSession0614-2">
                らくらホールディングス(コンサルタント・専門コンサルタント)
              </td>
              <td className="center compSession0614-2">
                クオリサイトテクノロジーズ(IT・情報処理)
              </td>
              <td className="center compSession0614-2">函館税関(官公庁)</td>
              <td className="center compSession0614-2">道路建設(建設業)</td>
            </tr>
            <tr>
              <td className="center break">5分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">12:15〜12:55</td>
              <td className="center column" colSpan="7">
                北海道の業界地図の読み方セミナー/北海学園大学教授　佐藤大輔先生(ルームA)
              </td>
            </tr>
            <tr>
              <td className="center break">5分休憩</td>

              <td className="center arrow" colSpan="6">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">13:00〜13:20</td>

              <td className="center compSession0614-1">全体説明</td>
              <td className="center compSession0614-2" colSpan="5">
                全体説明・オンライン説明会の受け方、事前知識セミナー（ルームA）
              </td>
            </tr>
            <tr>
              <td className="center time">13:20〜13:50</td>
              <td className="center compSession0614-1">4ターム</td>
              <td className="center compSession0614-2">
                サッポロドラッグストアー(小売業)
              </td>
              <td className="center compSession0614-2">
                クリプトン・フューチャー・メディア(IT・ソフトウェア)
              </td>
              <td className="center compSession0614-2">
                合田観光商事(アミューズメント)
              </td>
              <td className="center compSession0614-2">檜山鐵工所(鉄工業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">14:00〜14:30</td>
              <td className="center compSession0614-1">5ターム</td>
              <td className="center compSession0614-2">
                サッポロドラッグストアー(小売業)
              </td>
              <td className="center compSession0614-2">SOC(IT)</td>
              <td className="center compSession0614-2">
                らくらホールディングス(コンサルタント・専門コンサルタント)
              </td>
              <td className="center compSession0614-2">道路建設(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">14:40〜15:10</td>
              <td className="center compSession0614-1">6ターム</td>
              <td className="center compSession0614-2">
                ロゴスホーム(住宅・建設業)
              </td>
              <td className="center compSession0614-2">
                クオリサイトテクノロジーズ(IT・情報処理)
              </td>
              <td className="center compSession0614-2">函館税関(官公庁)</td>
              <td className="center compSession0614-2">井上技研(建設業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="7">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>

            <tr>
              <td className="center time">15:20〜15:50</td>
              <td className="center compSession0614-1">7ターム</td>
              <td className="center compSession0614-2">
                クリプトン・フューチャー・メディア(IT・ソフトウェア)
              </td>
              <td className="center compSession0614-2">
                キットアライブ(IT（システム開発）)
              </td>
              <td className="center compSession0614-2">札幌市役所(官公庁)</td>
              <td className="center compSession0614-2">
                生活協同組合コープさっぽろ(生活協同組合)
              </td>
            </tr>
          </tbody>
        </table>
        <p className="contents">
          当日スケジュールは予定です。参加企業数や運営の都合により変更することがございます。具体的な企業様名は随時更新となります。
        </p>

        <Header title="出展予定企業(随時追加)" name="peach-header3" />
        <Companies0529 data={props.companies.companies0614} />

        <Header title="出展実績" name="peach-header3" />
        <Companies data={props.companies.companies} />

        <Header title="学生実績" name="peach-header3" />
        <University data={props.companies.university0425} />

        <Header title="過去取材実績" name="peach-header3" />
        <ul className="contents">
          <li>
            <a href="・https://www.hokkaido-np.co.jp/article/411292">
              北海道新聞
            </a>
          </li>
          <li>
            <a href="https://www.nikkei.com/article/DGXMZO58470250U0A420C2L41000/">
              日経新聞
            </a>
          </li>
          <li>朝日新聞(5/18掲載予定)</li>
          <li>NHK:おはよう北海道(5/7)</li>
          <li>
            <a href="https://this.kiji.is/633488200549614689?c=462419638605612129">
              Tvh:けいナビ
            </a>
          </li>
        </ul>

        <Header title="企業様の参加方法" name="peach-header3" />
        <p className="contents">
          企業担当者様は
          <a href="https://docs.google.com/presentation/d/1KwjyN0Af_yDufyyF-Qz2TB0mmbd4ewc7PrD8FRaxuXE/edit?usp=sharing">
            こちら！(受付中)
          </a>
        </p>

        <Header title="主催/共催" name="peach-header3" />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://13labo.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={logo}
                  />
                </a>
                <p className="companyTitle">主催：13LABO(株式会社オガワヤ)</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://www.dialogger-inc.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={dialogger}
                  />
                </a>
                <p className="companyTitle">共催：合同会社Dialogger</p>
              </div>
            </Grid>
          </Grid>
          <Twemb />
        </div>

        {/*} <Header title='協力' />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="http://kk.hokkaido-np.co.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={hokkaido} />
                </a>
                <p className="companyTitle">北海道新聞社</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="https://jobdas.hokkaido-np.co.jp/2021/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={jobdas} />
                </a>
                <p className="companyTitle">ジョブダス就活</p>
              </div>
            </Grid>
          </Grid>
        </div>

        <Header title='後援' />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="http://www.pref.hokkaido.lg.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={white} />
                </a>
                <p className="companyTitle">北海道</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="https://www.city.sapporo.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={sapporo} />
                </a>
                <p className="companyTitle">札幌市</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="http://www.jobcafe-h.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={jobcafe} />
                </a>
                <p className="companyTitle">ジョブカフェ北海道</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3} >
              <div style={{ width: '100%', height: '100%' }}>
                <a href="https://no-maps.jp/" target="_blank" rel="noopener noreferrer">
                  <img
                    style={{ width: '100%', height: '80px', objectFit: 'contain' }}
                    alt="complex"
                    src={noMaps} />
                </a>
                <p className="companyTitle">NoMaps実行委員会</p>
              </div>
            </Grid>
          </Grid>
      </div>*/}

        <Header title="その他お問い合わせ" name="peach-header3" />
        <p className="contents">
          13LABOホームページよりお問い合わせください。
          <a href="https://13labo.com">お問い合わせフォーム</a>
        </p>

        <Header title="Special Thanks!" name="peach-header3" />
        <p className="contents">
          idea from<a href="https://twitter.com/jony_fj">ジョニー藤村様</a>
          <br />
          created by <a href="https://twitter.com/tanakarn98">tanaka</a>
          <br />
          icon from<a href="https://icons8.com">icons8</a>
        </p>
      </div>
    </>
  );
};

export default Session0614;
